import { Component, OnInit } from '@angular/core';
import { PPAuthService } from '../../core/services/auth.service';
import { User } from '../../core/models/user.model';

import { Subject, Subscription, Observable } from 'rxjs';
import { first, map, flatMap, tap, switchMap, switchAll, take } from 'rxjs/operators';

@Component({
  selector: 'app-consents',
  templateUrl: './consents.page.html',
  styleUrls: ['./consents.page.scss'],
})
export class ConsentsPage implements OnInit {

  //promotionsViaEmailToggle$:Subject<boolean> = new Subject();
  //promotionsViaSmsToggle$:Subject<boolean> = new Subject();

  providerToggle$:Subject<boolean> = new Subject();
  marketplaceToggle$:Subject<boolean> = new Subject();
  
  //private promotionsViaEmailToggleSub: Subscription;
  //private promotionsViaSmsToggleSub: Subscription;

  private marketplaceToggleSub: Subscription;
  private providerToggleSub: Subscription;

  me$: Observable<User>;

  constructor( private authService: PPAuthService ) {
    this.me$ = authService.me2$;
    authService.setMe();
  }

  ngOnInit() {

    /*this.promotionsViaEmailToggleSub = this.promotionsViaEmailToggle$.pipe(
    ).subscribe( value => {
      this.authService.updateConsentToggle('promotionsViaEmail', value);
    });

    this.promotionsViaSmsToggleSub = this.promotionsViaSmsToggle$.pipe(
    ).subscribe( value => {
      this.authService.updateConsentToggle('promotionsViaSms', value);
    });*/

    this.marketplaceToggleSub = this.marketplaceToggle$.pipe(
    ).subscribe( value => {

      this.authService.updateConsentToggleForMarketplace$( value ).subscribe(
        result  => { console.log('Saved...'); this.authService.setMe(); }

      );

    });

    this.providerToggleSub = this.providerToggle$.pipe(
    ).subscribe( value => {

      this.authService.updateConsentToggleForProvider$( value[0], value[1] ).subscribe(
        result  => { console.log('Saved...'); this.authService.setMe(); }
      );

    });
  }

  ngOnDestroy() {
    this.marketplaceToggleSub.unsubscribe();
    this.providerToggleSub.unsubscribe();
  }

}
